/** SA-1034 PR 5 (spec §3.4): the Conversations page's key lines, by key and view-as; one rule for
 *  voice and avatar since SA-1418 (B5). */
import { KEYS_UNAVAILABLE } from '@/components/auth/impersonationText'

export const VOICE_UNAVAILABLE_VIEW_AS = 'Voice: unavailable while viewing as another user'
export const AVATAR_UNAVAILABLE_VIEW_AS = 'Avatar: unavailable while viewing as another user'

export type KeyedService = 'voice' | 'avatar'

const WORDS: Record<KeyedService, { configured: string; addKey: string; unavailable: string }> = {
  voice: { configured: 'Voice TTS: Configured', addKey: 'Voice TTS: Add API key', unavailable: VOICE_UNAVAILABLE_VIEW_AS },
  avatar: { configured: 'Avatar: Configured', addKey: 'Avatar: Add API key', unavailable: AVATAR_UNAVAILABLE_VIEW_AS },
}

/** A keyed service's line. Under a view-as the viewer's keys are never read, so it says so. */
export function keyStatusWords(service: KeyedService, hasKey: boolean, viewingAs: boolean): { text: string; tip: string | null; ok: boolean } {
  const words = WORDS[service]
  if (viewingAs) return { text: words.unavailable, tip: KEYS_UNAVAILABLE, ok: false }
  return hasKey ? { text: words.configured, tip: null, ok: true } : { text: words.addKey, tip: null, ok: false }
}

export function voiceStatusWords(hasKey: boolean, viewingAs: boolean): { text: string; tip: string | null; ok: boolean } {
  return keyStatusWords('voice', hasKey, viewingAs)
}
